import React, {useState} from 'react'
import ReactTruncate from "react-truncate";

const TruncateServer = ({children}) => {
	return (
		<ReactTruncate lines={2}>{children}</ReactTruncate>					
	)
}

export default TruncateServer;